<template>
    <div class="create">
      <h2 v-if="!form.id">{{ $t('randevu.create.title_new') }}</h2>
      <h2 v-else>{{ $t('randevu.create.title_edit') }}</h2>
  
      <div class="form-row">
        <label>{{ $t('randevu.create.expert_label') }}</label>
        <select v-model.number="form.expert_id">
          <option :value="null" disabled>{{ $t('randevu.create.select_placeholder') }}</option>
          <option v-for="e in experts" :key="e.id" :value="e.id">
            {{ e.name }}
          </option>
        </select>
      </div>
  
      <div class="form-row">
        <label>{{ $t('randevu.create.customer_label') }}</label>
        <div class="customer-search" >
          <input
            type="text"
            v-model="customerSearch"
            @focus="showCustomerOptions = true"
            @input="showCustomerOptions = true"
            :placeholder="$t('randevu.create.customer_search_placeholder')"
          />
          <div v-if="showCustomerOptions" class="customer-options">
            <p class="add-new" @click="showCustomerForm = true"> {{ $t('randevu.create.add_new_customer') }} </p>
            <h4>{{ $t('randevu.create.registered_customers') }}</h4>

            <div class="cutomer-container">
               <li class="customerlist"
                 v-for="c in customers.filter(c => c.name.toLowerCase().includes(customerSearch.toLowerCase()))"
                 :key="c.id"
                 @click="selectCustomer(c)"
               >
                 {{ c.name }}
               </li>
            </div>

          </div>
        </div>
      </div>

      <div class="modaloverlay" v-if="showCustomerForm" >
        <div class="modal-contents">
          <CustomerAdd 
        @refresh="onCustomerAdded"
        @close="showCustomerForm = false"
      />
        </div> 
      </div>

  
      <div class="form-row">
        <label>{{ $t('randevu.create.start_label') }}</label>
        <input type="datetime-local" v-model="form.start_time" />
      </div>
  
      <div class="form-row">
        <label>{{ $t('randevu.create.end_label') }}</label>
        <input type="datetime-local" v-model="form.end_time" />
      </div>
  
      <h3>{{ $t('randevu.create.services_title') }} <span style="font-weight: 400;">{{ $t('randevu.create.services_qty_suffix') }}</span></h3>
      <div v-for="(row, i) in form.services" :key="i" class="service-row">
        <select v-model.number="row.service_id">
          <option :value="null" disabled>{{ $t('randevu.create.select_service') }}</option>
          <option v-for="s in services" :key="s.id" :value="s.id">{{ s.name }}</option>
        </select>
        <input type="number" min="1" v-model.number="row.quantity" />
        <button class="removebtn" @click="removeService(i)">X</button>
      </div>
      <button class="small" @click="addService">{{ $t('randevu.create.add_service') }}</button>
  
      <div class="form-row">
        <label>{{ $t('randevu.create.notes_label') }}</label>
        <textarea v-model="form.notes"></textarea>
      </div>
  
      <div class="form-actions">
        <button class="primary" @click="submit" :disabled="loading">
          {{ form.id ? $t('randevu.create.update') : $t('randevu.create.save') }}
        </button>
        <button class="cancel" @click="$emit('cancel')">{{ $t('randevu.create.cancel') }}</button>
      </div>
  
      <p v-if="success" class="success">{{ $t('randevu.create.success') }}</p>
      <p v-if="error" class="error">{{ error }}</p>
 
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import CustomerAdd from '../application/advanced/CustomerAdd.vue'
   
  const pad = n => String(n).padStart(2, '0')
   
  function toInputValue (d) {
    if (!(d instanceof Date)) d = new Date(d)  
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
           `T${pad(d.getHours())}:${pad(d.getMinutes())}`
  }
   
  function localToIso (str) { 
    const [y, m, d, hh, mm] = str.replace('T', '-').split(/[-:]/).map(Number)
    return new Date(y, m - 1, d, hh, mm).toISOString()
  }
  
  export default {
    name: 'CreateAppointment',
    components: { CustomerAdd },
  
    props: { prefill: Object },
  
    data () {
      return {
        experts: [],
        customers: [],
        services: [],
        loading: false,
        success: false,
        error: null,
  
        customerSearch: '',
        showCustomerOptions: false,
        showCustomerForm: false,
  
        form: {
          id: null,
          expert_id: null,
          customer_id: null,
          start_time: '', 
          end_time:   '',
          notes: '',
          services: [{ service_id: null, quantity: 1 }]
        }
      }
    },
   
    watch: { 
      prefill: {
        immediate: true,
        handler (val) {
          if (!val) return
   
          const clone = { ...val }
  
          if (val.start_time)
            clone.start_time = toInputValue(val.start_time + 'Z')  
          if (val.end_time)
            clone.end_time   = toInputValue(val.end_time   + 'Z')
  
          this.form = {
            ...this.form,
            ...clone,
            services: clone.services || [{ service_id: null, quantity: 1 }]
          }
  
          if (val.customer_name) this.customerSearch = val.customer_name
        }
      }
    },
   
    methods: { 
      async fetchLists () { 
        const [e, c, s] = await Promise.allSettled([
          axios.get('/promo/user/my-experts'),
          axios.get('/promo/user/my-customers'),
          axios.get('/promo/user/my-services')
        ])
       
        this.experts   = e.status === 'fulfilled' ? e.value.data : []
        this.customers = c.status === 'fulfilled' ? c.value.data : []
        this.services  = s.status === 'fulfilled' ? s.value.data : []
       
        if ([e, c, s].every(r => r.status === 'rejected')) {
          this.error = this.$t('randevu.create.missing_lists_error')
        } else {
          this.error = null  
        }
      },
   
      addService ()     { this.form.services.push({ service_id: null, quantity: 1 }) },
      removeService (i) { this.form.services.splice(i, 1) },
   
      selectCustomer (c) {
        this.form.customer_id = c.id
        this.customerSearch   = c.name
        this.showCustomerOptions = false
      },
  
      async onCustomerAdded () {
        this.showCustomerForm = false
        try {
          const res = await axios.get('/promo/user/my-customers')
          this.customers = res.data
        } catch (err) {
          console.error(err)
        }
      },
   
      async submit () {
        this.error   = null
        this.success = false
        this.loading = true
  
        try { 
          const payload = {
            ...this.form,
            start_time: localToIso(this.form.start_time),
            end_time:   localToIso(this.form.end_time)
          }
  
          if (this.form.id) {
            await axios.put(`/promo/user/appointments/${this.form.id}`, payload)
          } else {
            await axios.post('/promo/user/appointments', payload)
          }
  
          this.success = true
          this.$emit('success')
        } catch (err) {
          this.error = err.response?.data?.message || this.$t('randevu.create.generic_error')
        } finally {
          this.loading = false
        }
      }
    },
   
    mounted () { this.fetchLists() }
  }
  </script>
  
  
  <style scoped>
  .create {  
    max-width: 600px;
    margin: auto;
  }
  .form-row {
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
  }
  label {
    margin-bottom: 4px;
  } 
  textarea {
    min-height: 80px;
  }
  .service-row {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 8px;
  }
  .service-row select,
  .service-row input {
    flex: 1;
  }
  .removebtn {
    min-width: 1rem;
    max-width: 1rem;  
    background-color: #050505;
    padding: 10px 20px;
    border-color: #4d1818;
  }
  button.small {
    background: transparent;
    color: #106E35;
    border: 1px solid #106E35;
    padding: 4px 8px;
    cursor: pointer;
    border-radius: 0;
  } 
  .cancel {
    margin-left: 12px;
    background: #650101;
    color: #ccc;
    border: none;
    padding: 8px 16px;
    cursor: pointer;
  }
  .form-actions {
    display: flex;
    gap: 10px;
    margin-top: 16px;
  }
  .error {
    margin-top: 12px;
    color: #f44336;
  }
  .success {
    margin-top: 12px;
    color: #4caf50;
  }
  .primary{
    background-color: #106E35;
  }

  .customer-options{
    display: flex;
    flex-direction: column;
    gap: 5px; 
    background-color: #000;
  }
  .cutomer-container{
    display: flex;
    flex-direction: column;
    gap: 5px;
    max-height: 150px;
    overflow: auto;
    background-color: #000;
    padding: 1em;
    border: #0f2016 1px solid; 
  }
  h4{
    margin: 0;
    padding: 0;
  }
  .customerlist{ 
    padding: 5px 0;
    cursor: pointer;
    border-bottom: #0f2016 1px solid;
  }
  .customerlist:hover {
    color: white;
  }
  .add-new{ 
    color: #4caf50; 
    cursor: pointer;
    margin: 10px 0;
    border: 1px solid #4caf50;
    border-radius: 2rem;
    padding: 4px 6px;
    max-width: 8rem;
  } 

  .new-cus{ 
    padding: 1em;
    background-color: #022121;
    margin-bottom: 1rem;
  } 
  .modaloverlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 9999;
}
.modal-contents {
  margin-top: 1em;
  width: 100%;
  max-width: 620px;
  background-color: #011111;
  border-radius: 10px 10px 0 0;
  border-top: 1px solid #022121;
  border-left: 1px solid #022121;
  border-right: 1px solid #022121;
  padding: 1rem;
  overflow-y: auto;
  max-height: 80vh;
}

  </style>
  